import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import { translate } from 'services/i18nService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import FirebaseStore from 'stores/FirebaseStore';
import GroupShowStore from 'stores/GroupShowStore';
import UserStore from 'stores/UserStore';
import { SECOND_AS_MILLISECONDS } from 'enum/timeFormat';
import { getTimeStringWithoutHours } from 'utils/helpers';

import styles from './GroupShowDisconnectedState.css';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

const GroupShowDisconnectedState = (props) => {
  const { roomName, isDesktop } = props;
  const { remainingTimeLeftUntillGroupShow } = GroupShowStore;
  const { user: { sfw } } = UserStore;

  const [secondsCounter, setSecondsCounter] = useState(null);

  useEffect(() => {
    const { getRemainingTimeUntillGroupShow } = GroupShowStore;
    const { newShowsDetails } = FirebaseStore;
    const { currentStart, currentDuration } = newShowsDetails || {};

    getRemainingTimeUntillGroupShow(currentStart + currentDuration);
  }, []);

  useEffect(() => {
    setSecondsCounter(remainingTimeLeftUntillGroupShow);
    const interval =
      remainingTimeLeftUntillGroupShow !== null &&
      setInterval(() => {
        setSecondsCounter((counter) => counter - 1);
      }, SECOND_AS_MILLISECONDS);

    return () => clearInterval(interval);
  }, [remainingTimeLeftUntillGroupShow]);

  const avatarClasses = classNames({
    [styles.perfImg]: true,
    [styles.blur]: sfw,
  });

  const parsedSeconds = getTimeStringWithoutHours(secondsCounter);

  return (
    <div className={isDesktop ? styles.desktopContainer : styles.container}>
      <img
        alt="avatar"
        className={avatarClasses}
        src={`${BASE_URL}/avatar/user/60x60/${roomName}.jpg`}
      />
      <h2>{roomName}</h2>
      <div className={styles.redWrapper}>
        {translate('v2profile.group.show.disconnected')}
      </div>
      <p>{translate('v2profile.group.show.ended.unexpectedly')}</p>
      <p>{translate('v2profile.group.show.must.resume')}</p>
      <p>{secondsCounter <= 0 ? '00:00' : parsedSeconds}</p>
    </div>
  );
};

GroupShowDisconnectedState.propTypes = {
  isDesktop: PropTypes.bool,
  roomName: PropTypes.string,
};

GroupShowDisconnectedState.defaultProps = {
  isDesktop: false,
  roomName: undefined,
};

export default observer(GroupShowDisconnectedState);
